<template>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h5 class="title">Waitlist Table</h5>
          </div>
          <div class="card-body table-responsive table-full-width">
            <!-- Add a scrollable container -->
            <div class="scrollable-table">
              <el-table :data="tableData" height="500" stripe>
                <el-table-column label="ID" property="id" width="40px"></el-table-column>
                <el-table-column label="Name" property="name" width="250px"></el-table-column>
                <el-table-column label="Email" property="email" width="250px"></el-table-column>
                <el-table-column label="What is your budget to develop some of the world’s innovations?" width="400px" property="aiTask"></el-table-column>
                <!-- <el-table-column label="Solution Type" property="solutionType" width="150px"></el-table-column> -->
                <!-- <el-table-column label="Familiarity" property="familiar" width="150px"></el-table-column> -->
                <!-- <el-table-column label="Beta Testing" property="betaTesting" width="150px"></el-table-column> -->
                <el-table-column label="What would you use GenieAI for?" property="challenges" width="400px"></el-table-column>
                <el-table-column label="Have you ever lost an idea/thought in your head?" property="aiExcitement" width="500px"></el-table-column>

                <!-- <el-table-column label="Have you ever lost an idea/thought in your head?" width="500px">
                  <template #default="{ row }">
                    <div class="button-group">
                      <button
                        v-for="(excitement, index) in row.aiExcitement"
                        :key="index"
                        class="ai-excitement-btn"
                      >
                        {{ excitement }}
                      </button>
                    </div>
                  </template>
                </el-table-column> -->
                <!-- <el-table-column label="Timestamp" property="timestamp" width="150px"></el-table-column> -->
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import Vue from "vue";
  import { collection, getDocs } from "firebase/firestore";
  import db from "@/components/Firebase/firebaseInit";
  
  import { Table, TableColumn } from "element-ui";
  Vue.use(Table);
  Vue.use(TableColumn);
  
  export default {
    data() {
      return {
        tableData: [], // Stores the fetched data for the table
      };
    },
    created() {
      this.fetchRegistrations();
    },
    methods: {
      async fetchRegistrations() {
        try {
          let id = 1;
          const querySnapshot = await getDocs(collection(db, "registrations"));
          this.tableData = querySnapshot.docs.map((doc) => ({
            id: id++, // Generate unique IDs for the rows
            name: `${doc.data().firstName} ${doc.data().lastName}`, // Combine firstName and lastName
            email: doc.data().email, // Display email
            aiExcitement: doc.data().aiExcitement, // Keep array intact for button rendering
            aiTask: doc.data().aiTask, // Display the AI task
            solutionType: doc.data().solutionType, // Display solution type
            familiar: doc.data().familiar, // Familiarity with AI
            betaTesting: doc.data().betaTesting, // Beta testing response
            challenges: doc.data().challenges, // Challenges field
            timestamp: doc.data().timestamp.toDate().toLocaleString(), // Format timestamp as readable date
          }));
        } catch (error) {
          console.error("Error fetching registrations:", error);
        }
      },
    },
  };
  </script>
  
  <style scoped>
  /* Style for the AI excitement buttons */
  .button-group {
    display: flex;
    gap: 10px; /* Space between buttons */
    flex-wrap: wrap; /* Wrap buttons to the next line if necessary */
  }
  
  .ai-excitement-btn {
    padding: 8px 16px;
    border: 2px solid #00cffd;
    border-radius: 8px;
    background-color: transparent;
    color: #00cffd;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.3s ease;
  }
  
  .ai-excitement-btn:hover {
    background-color: #00cffd;
    color: #ffffff;
  }
  
  /* Scrollable table container */
  .scrollable-table {
    max-height: 500px; /* Adjust height as needed */
    overflow-y: auto; /* Enable vertical scrolling */
    overflow-x: auto; /* Enable horizontal scrolling */
    border: 1px solid #ddd; /* Optional border for better UI */
  }
  
  .el-table {
    min-width: 1200px; /* Ensure table doesn't shrink too much */
  }
  </style>
  